export default function ReviewStatus({ name, color }) {
  return <span style={{ color }}>{name}</span>;
}
